import { isNull } from "App/utils/helpers";
import { useDispatchWrapper } from "hooks";
import React from "react";
import "./ModalStyle.scss";

export default function Modal(props) {
  const { state } = useDispatchWrapper();
  const themeList = state.theme_list;
  const {
    title,
    backgroundTitle = isNull(themeList.tab_active)
      ? "#0FB054"
      : themeList.tab_active,
    colorTitle = isNull(themeList.tab_active_color)
      ? "#FFF"
      : themeList.tab_active_color,
    subtitle,
    show,
    width = "40%",
    maxWidth = "90%",
    children,
    activeZindex = false,
    zindex,
    offsiteClose = true,
  } = props;

  return (
    <div
      className="modal-root"
      style={activeZindex ? { zIndex: zindex } : {}}
      onClick={(e) => {
        if (offsiteClose === true) {
          const target = e.target;
          if (target.className === "modal-root") {
            show(false);
          }
        }
      }}
    >
      <div
        className="modal-content "
        style={{
          width: width,
          maxWidth: maxWidth,
        }}
      >
        <div
          className="modal-title"
          style={{
            background: `${backgroundTitle}`,
            color: `${colorTitle}`,
          }}
        >
          <div>
            <p className="title">{title}</p>
            <p className="subtitle">{subtitle}</p>
          </div>
          <button
            type="button"
            className="x-button"
            onClick={() => show(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="x-icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <hr />
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}
